<template>
  <section class="wrap">
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small">
      <el-card class="base-info">
        <p class="title">基本信息</p>
        <el-form-item label="卡片名称：" prop="name">
          <el-input placeholder="请输入卡片名称" v-model.trim="form.name" class="width_short" maxlength="15"></el-input>
          <span class="label-tip">15个字以内</span>
        </el-form-item>
        <el-form-item label="SKU名称：" prop="skuName">
          <el-input
            placeholder="请输入SKU名称"
            v-model.trim="form.skuName"
            class="width_short"
            maxlength="8"
          ></el-input>
          <span class="label-tip">8个字以内；展示在VIP主页-选择卡片价格上方</span>
        </el-form-item>
        <el-form-item label="选择卡种：" prop="vipCardTypeId">
          <el-select
            v-model="form.vipCardTypeId"
            placeholder="请选择卡种"
            size="small"
            class="width_short"
            @change="changeVipType"
          >
            <el-option v-for="item in vipTypeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择周期：" prop="periodDay">
          <el-select
            v-model="form.periodDay"
            placeholder="请选择周期"
            size="small"
            class="width_short"
            @change="changePeriodDay"
          >
            <el-option v-for="item in allPeriodDayList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消耗优先级：" prop="priority">
          <el-input
            placeholder="请输入消耗优先级"
            v-model.trim.number="form.priority"
            class="width_short"
            maxlength="6"
            oninput="value=value.replace(/[^\d.]/g,'')"
          ></el-input>
          <span class="label-tip">6位数以内，多个VIP时，数字越高消耗优先级越高</span>
        </el-form-item>
        <el-form-item label="权重：" prop="weight">
          <!-- <el-input placeholder="请输入权重" v-model.trim.number="form.weight" class="width_short" maxlength="8"
            oninput="value=value.replace(/[^\d.]/g,'')"></el-input> -->
          <el-input-number
            v-model.number="form.weight"
            class="width_short"
            :min="0"
            :max="999999"
            placeholder="请输入权重"
            @change="(val) => (form.weight = val || '')"
          ></el-input-number>
          <span class="label-tip">6个字以内；VIP主页卡片展示顺序</span>
        </el-form-item>
        <el-form-item label="公开：" prop="weight">
          <el-switch
            v-model="form.isOpen"
            :active-value="true"
            :inactive-value="false"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
          <span class="label-tip">关闭后将不在页面中展示，仍可正常使用</span>
        </el-form-item>
      </el-card>
      <!-- 营销文案 -->
      <el-card class="copy-writing" style="margin-top: 20px">
        <p class="title">营销文案</p>
        <el-form-item label="卡片左上角：" prop="topLeftText">
          <el-input
            placeholder="请输入卡片左上角文案"
            v-model.trim="form.topLeftText"
            class="width_short"
            maxlength="10"
          ></el-input>
          <span class="label-tip">10个字以内；展示在VIP主页卡片左上角</span>
        </el-form-item>
        <el-form-item label="卡片底部：" prop="bottomText">
          <el-input
            placeholder="请输入卡片底部文案"
            v-model.trim="form.bottomText"
            class="width_short"
            maxlength="8"
          ></el-input>
          <span class="label-tip">8个字以内；展示在VIP主页卡片下方</span>
        </el-form-item>
        <el-form-item label="课程引流推荐语：" prop="courseRecommendText">
          <el-input
            placeholder="请输入课程引流推荐语"
            v-model.trim="form.courseRecommendText"
            class="width_short"
            maxlength="8"
          ></el-input>
          <span class="label-tip">8个字以内；展示在课程/课程源支付按钮右上角</span>
        </el-form-item>
        <el-form-item label="VIP主页底部按钮：" prop="vipHomepageBottomText">
          <el-input
            placeholder="请输入VIP主页底部按钮文案"
            v-model.trim="form.vipHomepageBottomText"
            class="width_short"
            maxlength="8"
          ></el-input>
          <span class="label-tip">8个字以内；展示在VIP主页底部滚动按钮价格右侧</span>
        </el-form-item>
        <el-form-item label="课程按钮：" prop="courseButtonText">
          <el-input
            placeholder="请输入课程按钮文案"
            v-model.trim="form.courseButtonText"
            class="width_short"
            maxlength="12"
          ></el-input>
          <span class="label-tip">12个字以内；展示在课程/课程源支付按钮</span>
        </el-form-item>
        <el-form-item label="团购落地页副标题：" prop="groupBuySubTitle">
          <el-input
            placeholder="请输入团购落地页副标题"
            v-model.trim="form.groupBuySubTitle"
            class="width_short"
            maxlength="15"
          ></el-input>
          <span class="label-tip">15个字以内；展示在团购落地页卡片的副标题</span>
        </el-form-item>
        <!-- <el-form-item label="学科主页VIP营销文案：" prop="subjectHomepageVipMarketing">
          <el-input placeholder="请输入学科主页VIP营销文案" v-model.trim="form.subjectHomepageVipMarketing" class="width_short"
            maxlength="12"></el-input>
          <span class="label-tip">
            12个字以内；展示在学科主页VIP入口副标题</span>
        </el-form-item> -->
      </el-card>
      <!-- 价格设置 -->
      <el-card class="price-setting" style="margin-top: 20px">
        <p class="title">价格设置</p>
        <el-form-item label="卡片类型：" prop="type">
          <el-select v-model="form.type" class="width_short" placeholder="请选择卡片类型" size="small">
            <el-option v-for="item in cardTypeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <!-- <el-input placeholder="请输入价格" v-model.trim.number="form.price" class="width_short" maxlength="6"></el-input> -->
          <el-input-number
            class="width_short"
            v-model="form.price"
            :precision="1"
            size="small"
            :min="0"
            :max="999999"
            maxlength="6"
            @change="(val) => (form.price = val || '')"
          ></el-input-number>
          <span class="label-tip">元 （6位数以内）</span>
        </el-form-item>
        <el-form-item label="价格锚点：" prop="isPriceAnchor">
          <el-switch
            v-model="form.isPriceAnchor"
            :active-value="true"
            :inactive-value="false"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
          <span class="label-tip">展示在VIP主页的最后一个卡片；多个时，展示权重最高的卡片</span>
        </el-form-item>
      </el-card>

      <!-- 功能权益 -->
      <el-card class="function-subject" style="margin-top: 20px">
        <p class="title">功能权益</p>
        <ul>
          <li>
            <div class="name">权益名称</div>
            <div class="setting">权益设置</div>
          </li>
          <li>
            <div class="name">下载课件</div>
            <el-form-item class="setting" prop="downloadCoursewareCount" label-width="0">
              <span>下载次数</span>
              <el-input
                placeholder="请输入下载次数"
                v-model.trim.number="form.downloadCoursewareCount"
                class="width_short"
                maxlength="6"
                :disabled="!selectVipType.isDownloadCourseware"
                oninput="value=value.replace(/[^\d.]/g,'')"
              ></el-input>
            </el-form-item>
          </li>
          <li>
            <div class="name">学习营提问</div>
            <el-form-item class="setting" prop="campAskCount" label-width="0">
              <span>提问次数</span>
              <el-input
                placeholder="请输入提问次数"
                v-model.trim.number="form.campAskCount"
                class="width_short"
                maxlength="6"
                :disabled="!selectVipType.isCampAsk"
                oninput="value=value.replace(/[^\d.]/g,'')"
              ></el-input>
            </el-form-item>
          </li>
          <li>
            <div class="name">线下培训折扣</div>
            <el-form-item class="setting" prop="offlineTrainingDiscount" label-width="0">
              <span>设置折扣</span>
              <el-input
                placeholder="请输入"
                v-model.trim.number="form.offlineTrainingDiscount"
                class="width_short"
                :min="0"
                :max="100"
                maxlength="3"
                :disabled="!selectVipType.isOfflineTrainingDiscount"
                oninput="value=value.replace(/[^\d.]/g,'')"
                @input="handleChangeDiscount"
              ></el-input>
              <span class="label-tip">%</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">赠课</div>
            <el-form-item class="setting" label-width="0">
              <el-switch
                v-model="selectVipType.isGiftCourse"
                :active-value="true"
                :inactive-value="false"
                active-color="#13ce66"
                inactive-color="#ff4949"
                disabled
              ></el-switch>
              <span class="label-tip">只限赠送【允许VIP免费观看】的课程</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">直播优先级答疑</div>
            <el-form-item class="setting" label-width="0">
              <span>权重</span>
              <span class="label-tip">{{ selectVipType.answerWeight }}</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">1080P画质</div>
            <el-form-item class="setting" label-width="0">
              <div class="label-tip">{{ selectVipType.is1080pQuality ? '允许观看' : '不允许观看' }}</div>
            </el-form-item>
          </li>
        </ul>
      </el-card>
      <el-form-item label-width="0" style="margin-top: 20px; margin-left: 60px">
        <el-button size="small" @click="cloesPage">取消</el-button>
        <el-button type="primary" size="small" :disabled="vipCardDisabled" @click="saveHandle">保存</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script scoped>
import exchange from '@/utils/exchange'
import requestApi from '@/api/operateManage/vipCard'
export default {
  name: 'vipCardPage',
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      vipCardId: '',
      form: {
        name: '',
        skuName: '',
        vipCardTypeId: '', // 卡种
        periodDay: '', // 周期
        priority: '', // 消耗优先级
        weight: '', // 权重
        isOpen: true, // 是否公开
        topLeftText: '', // 卡片左上角
        bottomText: '', // 卡片底部
        courseRecommendText: '', // 课程引流推荐语
        vipHomepageBottomText: '', // VIP主页底部按钮
        courseButtonText: '', // 课程按钮
        groupBuySubTitle: '', // 团购落地副标题
        // subjectHomepageVipMarketing: '', // 学科主页VIP营销文案
        type: '', // 卡片类型
        price: '', // 价格
        isPriceAnchor: false, // 是否是价格锚点
        downloadCoursewareCount: 0, // 下载次数
        offlineTrainingDiscount: 100, // 折扣
        campAskCount: 0, // 提问次数
        isGiftCourse: 1, // 是否赠课
        weight: 0 // 权重
      },
      rules: {
        name: { required: true, message: '请输入卡片名称', trigger: 'blur' },
        skuName: { required: true, message: '请输入SKU名称', trigger: 'blur' },
        vipCardTypeId: { required: true, message: '请选择卡种', trigger: 'change' },
        periodDay: { required: true, message: '请选择周期', trigger: 'change' },
        priority: { required: true, message: '请输入消耗优先级', trigger: 'blur' },
        weight: { required: true, message: '请输入权重', trigger: 'blur' },
        isOpen: { required: true, message: '请输入选择是否公开', trigger: 'blur' },
        bottomText: { required: true, message: '请输入卡片底部文案', trigger: 'blur' },
        courseRecommendText: { required: true, message: '请输入课程引流推荐语', trigger: 'blur' },
        vipHomepageBottomText: { required: true, message: '请输入VIP主页底部按钮文案', trigger: 'blur' },
        courseButtonText: { required: true, message: '请输入课程按钮文案', trigger: 'blur' },
        groupBuySubTitle: { required: true, message: '请输入团购落地页副标题', trigger: 'blur' },
        // subjectHomepageVipMarketing: { required: true, message: '请输入学科主页VIP营销文案', trigger: 'blur' },
        type: { required: true, message: '请输入卡片类型', trigger: 'blur' },
        price: { required: true, message: '请输入价格', trigger: 'blur' },
        isPriceAnchor: { required: true, message: '请选择价格锚点', trigger: 'change' }
      },
      vipTypeList: [], // vip所属卡种
      selectVipType: {
        isDownloadCourseware: false, // 是否能下载课件
        isCampAsk: false, // 是否能学习营提问
        isOfflineTrainingDiscount: false, // 是否有线下培训折扣
        isGiftCourse: false, // 是否能够赠课
        answerWeight: 0, // 权重
        is1080pQuality: false // 是否能看1080P画质
      }, // 当前选中卡种 （false-不能 true-能）
      allPeriodDayList: [
        {
          name: '1天（1天卡）',
          desc: '天',
          value: 1
        },
        {
          name: '3天（3天卡）',
          desc: '天',
          value: 3
        },
        {
          name: '5天（5天卡）',
          desc: '天',
          value: 5
        },
        {
          name: '7天（周卡）',
          desc: '周',
          value: 7
        },
        {
          name: '30天（月卡）',
          desc: '月',
          value: 30
        },
        {
          name: '90天（季卡）',
          desc: '季',
          value: 90
        },
        {
          name: '365天（年卡）',
          desc: '年',
          value: 365
        },
        {
          name: '730天（两年卡）',
          desc: '2年',
          value: 730
        },
        {
          name: '1095天（三年卡）',
          desc: '3年',
          value: 1095
        }
      ],
      cardTypeList: [
        {
          id: 1,
          name: '体验卡'
        },
        {
          id: 2,
          name: '团购卡'
        },
        {
          id: 3,
          name: '正价卡'
        }
      ], // vip 卡种类型
      vipCardDisabled: false
    }
  },
  activated() {
    this.vipCardId = this.$route.params.id
    this.getVipTypeList()
  },
  methods: {
    // 卡种列表
    getVipTypeList() {
      requestApi
        .getCardType()
        .then((res) => {
          if (res.Success) {
            this.vipTypeList = res.Data
            if (this.vipCardId) {
              this.getVipCardDetail()
            }
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch((res) => {
          console.log(res)
        })
    },
    // 详情
    getVipCardDetail() {
      requestApi.detail(this.vipCardId).then((res) => {
        if (res.Success) {
          res.Data.price = exchange.parseWallet_money(res.Data.price)
          this.form = res.Data
          // 功能权益设置
          this.vipTypeList.forEach((item) => {
            if (item.id === this.form.vipCardTypeId) {
              this.selectVipType = item
            }
          })
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    // 更改卡种
    changeVipType(val) {
      this.selectVipType = this.vipTypeList.filter((item) => item.id === val)[0]
      // 重置权益，当没有权益权限时
      if (!this.selectVipType.isDownloadCourseware) {
        this.form.downloadCoursewareCount = 0
      }
      if (!this.selectVipType.isCampAsk) {
        this.form.campAskCount = 0
      }
      if (!this.selectVipType.isOfflineTrainingDiscount) {
        this.form.offlineTrainingDiscount = 100
      }
    },
    // 更换周期
    changePeriodDay(val) {
      this.form.periodDesc = this.allPeriodDayList.filter((item) => item.value === val)[0].desc
    },
    // 折扣
    handleChangeDiscount(val) {
      if (/^(0|[1-9][0-9]*)$/.test(this.form.offlineTrainingDiscount)) {
        // 转换为整数并限制范围为0-100
        let num = parseInt(this.form.offlineTrainingDiscount)
        if (num < 0) {
          num = 0
        } else if (num > 100) {
          num = 100
        }
        this.form.offlineTrainingDiscount = num
      }
    },
    // 保存
    saveHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.vipCardDisabled = true
          let data = JSON.parse(JSON.stringify(this.form))
          data.price = exchange.toWallet_money(data.price)
          // 获取卡种权限
          const {
            isDownloadCourseware,
            isCampAsk,
            isOfflineTrainingDiscount,
            isGiftCourse,
            answerWeight,
            is1080pQuality
          } = this.selectVipType
          const vipType = {
            isDownloadCourseware,
            isCampAsk,
            isOfflineTrainingDiscount,
            isGiftCourse,
            answerWeight,
            is1080pQuality
          }
          // 合并卡片和卡种
          data = Object.assign(data, vipType)
          requestApi.save(data).then((res) => {
            this.vipCardDisabled = false
            if (res.Success) {
              if (this.PAGEKEY === 'vipCardAdd') {
                this.$message.success('添加成功！')
              } else {
                this.$message.success('编辑成功！')
              }
              this.cloesPage()
            } else {
              this.$message.error(res.Msg)
            }
          })
        }
      })
    },
    // 关闭tab
    cloesPage() {
      this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
      this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.label-tip {
  color: grey;
  margin: 0 10px;
  opacity: 0.8;
}

.function-subject ul li {
  display: flex;
  align-items: center;
  list-style: none;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  width: 80%;

  &:first-child {
    background-color: #647998;
    color: #fff;
    font-weight: 700;
    height: 50px;
    line-height: 50px;

    .name {
      text-align: center;
    }

    .setting {
      justify-content: center;
    }
  }

  .name {
    width: 30%;
    text-align: center;
    border-left: 1px solid #8496bf;
    border-right: 1px solid #8496bf;
    border-bottom: 1px solid #8496bf;
  }

  .setting {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    padding: 0 15px;
    width: 70%;
    height: 100%;
    border-bottom: 1px solid #8496bf;
    border-right: 1px solid #8496bf;

    span:first-child {
      display: inline-block;
      margin-right: 15px;
      width: 56px;
    }

    .width_short {
      min-width: 150px;
    }

    /deep/ .el-form-item__error {
      margin-left: 74px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/vipCard/components/vipCardPage.vue